// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"ffbb25e192b0a4f7c2a5","678":"33f4b459374aca0a8fec","883":"72248b0b05b8f0ba13d1"}[chunkId] + ".js";
};